import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";

import { SYS4030_R01Dto } from "./Dto_SYS4030_R01";
import { SYS4030_R01Filter } from "./Store_SYS4030_R01";
import exp from "constants";

const baseUrl = `${config.apiUrl}/SYS4030_R01`;

export const getSYS4030_R01List = async (option: string, params: Partial<SYS4030_R01Filter>, listLength: number = 0) => {
    const url = `${baseUrl}/${option}`
    return await getData<ResponseDto<SYS4030_R01Dto[]>>(url, {
        params: { 
            ...params,
            listLength: listLength ?? 0
        } as SYS4030_R01Filter
    });
}

export const getSYS4030_R01AllCount = async (params: Partial<SYS4030_R01Filter>) => {
    const url = `${baseUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, {
        params: {
            ...params
        }
    });
}

// export const getOrgDetail = async (orgCd: string) => {
//     const url = `${baseUrl}/organization/${orgCd}`;
//     return await getData<ResponseDto<SYS4030_R01Dto>>(url);
// }

export const postSYS4030_R01 = async (data: SYS4030_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await postData<SYS4030_R01Dto[], ResponseDto<SYS4030_R01Dto[]>>(url, data);
}

export const patchSYS4030_R01 = async (data: SYS4030_R01Dto[]) => {
    const url = `${baseUrl}`;

    return await patchData<SYS4030_R01Dto[], ResponseDto<SYS4030_R01Dto[]>>(url, data);
}

export const disableSYS4030_R01 = async (data: string[]) => {
    const url = `${baseUrl}/disable`;
    return await patchData<string[], ResponseDto<any>>(url, data);
}

export const deleteSYS4030_R01 = async (warehouseCd: string) => {
    const url = `${baseUrl}/${warehouseCd}`;
    return await deleteData<ResponseDto<any>>(url);
}

export const downloadExcel_SYS4030_R01 = async (option: string, params: Partial<SYS4030_R01Filter>, listLength: number = 0) => {
    
    const url = `${baseUrl}/excel/${option}`

    return await getData<ResponseDto<string>>(url, {
        params: { 
            ...params,
            listLength: listLength ?? 0 
        } as SYS4030_R01Filter
    });
}